export default {
  'YWX01': {
    title: '党建引领',
    desc: '简单说明简单说明说明',
    icon: 'dangjian1',
    color: '#fa2900',
    show: false
  },
  'YWX02': {
    title: '纪检',
    desc: '简单说明简单说明说明',
    icon: 'a-41',
    color: '#45bc7d',
    show: false
  },
  'YWX03': {
    title: '工会服务',
    desc: '简单说明简单说明说明',
    icon: 'a-21',
    color: '#ffc757',
    show: false
  },
  'YWX04': {
    title: '青团建设',
    desc: '简单说明简单说明说明',
    icon: 'a-31',
    color: '#ffc757',
    show: false
  },
  'YWX05': {
    title: '企业文化',
    desc: '简单说明简单说明说明',
    icon: 'a-51',
    color: '#ff8f82',
    show: false
  },
  'YWX06': {
    title: '数字CCO',
    desc: '简单说明简单说明说明',
    icon: 'a-61',
    color: '#009ad8',
    show: false
  }
}